import styled from '@emotion/styled';
import { colors } from '@modernanimal/common';

import Fonts from '../fonts';
import { DOWNLOAD_APP_LINK, HREF_TARGET } from '../helpers';
import images from '../images';

const CONTACT_PHONE_NUMBER = '(855) 228-7066';

const ExistingAccount = () => (
    <ExistingAccountContainer>
        <Header>
            <Fonts.Heading04Rza>
                Please book this appointment in the app
            </Fonts.Heading04Rza>
        </Header>
        <Body>
            <Fonts.Body style={{ color: colors.GREY_2 }}>
                {'Returning members, please book through the Modern Animal app — it\'s the best way to get care, '}
                {'chat with our 24/7 team, view records, and manage appointments.'}
                <br />
                <br />
                {'If you prefer, you can reach out to '}
                <Link
                    href={`tel:${CONTACT_PHONE_NUMBER}`}
                    style={{ textDecoration: 'none' }}
                >
                    {CONTACT_PHONE_NUMBER}
                </Link>
                {' for help booking this appointment.'}
            </Fonts.Body>
            <PreviewImage src={images.DownloadApp} />
            <Divider />
            <DownloadAppButton onClick={() => window.open(DOWNLOAD_APP_LINK, HREF_TARGET)}>
                <Fonts.LabelMedium style={{ color: colors.WHITE, cursor: 'pointer' }}>
                    Download app
                </Fonts.LabelMedium>
            </DownloadAppButton>
        </Body>
    </ExistingAccountContainer>
);

export default ExistingAccount;

const ExistingAccountContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 600px;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${colors.LINE};
`;

const DownloadAppButton = styled.button`
    display: flex;
    padding: 14px;
    background-color: ${colors.PRIMARY_PERIWINKLE};
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: none;
    cursor: pointer;
`;

const Header = styled.div`
    display: flex;
    padding: 16px;
    align-items: center;
    justify-content: center;
`;

const Link = styled.a`
    color: ${colors.PRIMARY_PERIWINKLE};
`;

const PreviewImage = styled.img`
    width: 100%;
`;
